var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useState } from 'react';
import ReactDOM from 'react-dom';
import menuContext from '../Contexts/menuContext';
import './MenuButton.css';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
var dropMenu = React.forwardRef(function (props, ref) {
    var menuMaxWidth = props.menuStyle && props.menuStyle.width ? null : '180px';
    return (_jsx(menuContext.Provider, __assign({ value: { submenu: true } }, { children: _jsx("div", __assign({ ref: ref, className: props.className + ' Menu ' + props.menuClass, style: __assign(__assign({ maxWidth: menuMaxWidth }, props.style), props.menuStyle), onClick: props.onClickBody }, { children: typeof (props.MenuContent) == 'function' ? _jsx(props.MenuContent, __assign({}, props.menuProps), void 0) : props.MenuContent }), void 0) }), void 0));
});
dropMenu.displayName = 'dropMenu';
var Direction;
(function (Direction) {
    Direction["Left"] = "left";
    Direction["Right"] = "right";
    Direction["Up"] = "up";
    Direction["Down"] = "down";
})(Direction || (Direction = {}));
export default function MenuButton(props) {
    var _a = useState(false), toggling = _a[0], setToggling = _a[1];
    //handles both onOpen and onClose
    function toggleHandler(isOpen) {
        if (!toggling && isOpen && props.onOpen) {
            props.onOpen();
        }
        else if (!toggling && props.onClose && !isOpen) {
            props.onClose();
            setToggling(true);
        }
        //Prevent spamming
        setTimeout(function () { return setToggling(false); }, 300);
    }
    //check if it's inside of another menu, if so render as a submenu
    var parentMenuData = useContext(menuContext);
    var icon = parentMenuData.submenu ? _jsx("span", __assign({ className: 'subMenuIcon' }, { children: _jsx(FontAwesomeIcon, { icon: faCaretRight }, void 0) }), void 0) : null;
    var direction = props.direction;
    if (parentMenuData.submenu) {
        direction = Direction.Right;
    }
    var notifications = props.notifications && props.notifications < 99 ? props.notifications : '99+';
    var notificationBadge = props.notifications ?
        _jsx("span", __assign({ className: 'notifications', style: props.notificationStyle }, { children: notifications }), void 0)
        : null;
    //button
    var dropButton = React.forwardRef(function (_a, ref) {
        var onClick = _a.onClick;
        function clickHandler(e) {
            e.preventDefault();
            onClick(e);
        }
        return (_jsxs("button", __assign({ className: 'MenuButton ' + props.className, onClick: clickHandler, ref: ref, style: props.style, title: props.title }, { children: [notificationBadge, props.children, icon] }), void 0));
    });
    dropButton.displayName = 'dropButton';
    //Prevent submenus from sticking around after their parent has closed
    function onClickBody() {
        if (parentMenuData.submenu || !props.permanent) {
            document.body.click();
        }
    }
    return (_jsx("span", __assign({ className: 'menuButtonContainer' }, { children: _jsxs(Dropdown, __assign({ drop: direction, onToggle: toggleHandler }, { children: [_jsx(Dropdown.Toggle, { as: dropButton }, void 0), ReactDOM.createPortal(_jsx(Dropdown.Menu, { as: dropMenu, MenuContent: props.menuContent, menuProps: props.menuProps || {}, menuStyle: props.menuStyle, style: {}, menuClass: '', onClickBody: onClickBody }, void 0), document.body)] }), void 0) }), void 0));
}
//# sourceMappingURL=MenuButton.js.map